import React from 'react';

import Affiliate from '../../../Api/Models/Affiliate';
import DetachElement from '../../elements/DetachElement';
import ProtectedLink from '../../elements/ProtectedLink';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import { ROLES } from '../../services/AdminPolicyService';

import QRCodeModal from './QRCodeModal';

import { PERMISSION } from 'crm/helpers/Permissions';

type Props = Readonly<{
    affiliate: Affiliate;
    url: string;
    getAffiliate: () => void;
}>;

function AffiliateDetails({ affiliate, url, getAffiliate }: Props) {
    const cardHeader = (
        <div className="d-flex justify-content-between">
            Affiliate details
            <QRCodeModal index={affiliate.qrCodes.index} casino={affiliate.qrCodes.casino} />
        </div>
    );

    return (
        <Card title={cardHeader}>
            <TableDetailsBody>
                <Row label="ID">{affiliate.id}</Row>
                <Row label="Name">{affiliate.name}</Row>
                <Row label="Token">{affiliate.token}</Row>
                <Row label="Link">{affiliate.affLink}</Row>
                <Row label="Unique click count">{affiliate.uniqueClickCount}</Row>
                <Row label="Register count">{affiliate.registerCount}</Row>
                <Row label="Sub register count">{affiliate.subRegisterCount}</Row>
                <Row label="Deposit sum">{affiliate.depositSum}</Row>
                <Row label="Purchase sum">{affiliate.purchaseSum}</Row>

                {affiliate.hasAdmin() && (
                    <>
                        <Row label="Affiliate revenue">{affiliate.adminRevenue}%</Row>
                        <Row label="Owner">
                            <ProtectedLink
                                url={`/admins/${affiliate.adminId}`}
                                value={affiliate.adminName}
                                permissions={[PERMISSION.VIEW_ADMIN]}
                            />
                            <span className="float-right">
                                <DetachElement
                                    url={`${url}/admins`}
                                    params={{ admin: affiliate.adminId }}
                                    action={getAffiliate}
                                    roles={ROLES.MAIN_ADMINS}
                                />
                            </span>
                        </Row>
                    </>
                )}
            </TableDetailsBody>
        </Card>
    );
}

export default AffiliateDetails;
